module.exports = __webpack_public_path__ + "img/H03092-01.7a35d316.jpg";